import { KeyValueStore } from '@frontend/utils';

const KEY = 'portal_session_token';

export const getAuthToken = async () => {
  return await KeyValueStore.get(KEY);
};

export const setAuthToken = async (sessionToken: string) => {
  await KeyValueStore.set(KEY, sessionToken);
};

export const clearAuthToken = async () => {
  await KeyValueStore.remove(KEY);
};
